import React, { useContext, useEffect, FC } from 'react';
import Blade from '../Blade';
import { Typography } from '../Typography';
import { Spacer } from '../Spacer';
import { UiStateContext } from '../../context/UiStateContext';
import { Login } from './Login';
import { Panel } from '../Panel';
import { UserContext } from '../../context/UserContext';
import { RegisterCallToAction } from './RegisterCallToAction';

interface CreatePropertyAlertLoginOrRegisterBladeProps {}

export const CreatePropertyAlertLoginOrRegisterBlade: FC<CreatePropertyAlertLoginOrRegisterBladeProps> = () => {
  const { setActiveBlade } = useContext(UiStateContext);
  const { loading, user } = useContext(UserContext);

  useEffect(() => {
    // Check if user has logged in and go fetch the saved properties
    if (!loading && user) {
      setActiveBlade('createPropertyAlert');
    }
  }, [user, loading]);

  return (
    <Blade id="createPropertyAlertLoginOrRegister">
      <Spacer>
        <Typography component="h2" variant="displaySmall">
          Log in to MyKFH to create property alerts
        </Typography>
        <Panel border>
          <Login disableRedirect />
        </Panel>
        <RegisterCallToAction />
      </Spacer>
    </Blade>
  );
};
